import { ServiceType } from '@baserow/modules/core/serviceTypes'

export class TTLockListDevicesServiceType extends ServiceType {
  static getType() {
    return 'ttlock_list_devices'
  }

  get name() {
    return this.app.$i18n.t('serviceType.ttlockListDevices')
  }

  get description() {
    return this.app.$i18n.t('serviceType.ttlockListDevicesDescription')
  }

  isValid() {
    return true
  }

  getOrder() {
    return 90
  }
}

export class TTLockIssuePeriodPasscodeServiceType extends ServiceType {
  static getType() {
    return 'ttlock_issue_period_passcode'
  }

  get name() {
    return this.app.$i18n.t('serviceType.ttlockIssuePeriodPasscode')
  }

  get description() {
    return this.app.$i18n.t('serviceType.ttlockIssuePeriodPasscodeDescription')
  }

  isValid() {
    return true
  }

  getOrder() {
    return 91
  }
}

export class TTLockRevokePasscodeServiceType extends ServiceType {
  static getType() {
    return 'ttlock_revoke_passcode'
  }

  get name() {
    return this.app.$i18n.t('serviceType.ttlockRevokePasscode')
  }

  get description() {
    return this.app.$i18n.t('serviceType.ttlockRevokePasscodeDescription')
  }

  isValid() {
    return true
  }

  getOrder() {
    return 92
  }
}
